// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '../../Geometry';
export class SymbolMapItem {
    constructor(parentIndustryMap, data) {
        this.Visible = true;
        this.Rectangle = Rectangle.Empty();
        this.parentIndustryMap = parentIndustryMap;
        this.symbolMap = data;
    }
    get ParentIndustryMap() {
        return this.parentIndustryMap;
    }
    // Свойство HeatmapData
    get heatmapData() {
        return this.symbolMap;
    }
    getSymbolBackgroundColor() {
        return this.parentIndustryMap.getSymbolBackgroundColor(this.symbolMap.changePercent);
    }
    get Weight() {
        return this.symbolMap.Weight;
    }
}
